import { render, staticRenderFns } from "./VizApp.vue?vue&type=template&id=45ab97ca"
import script from "./VizApp.vue?vue&type=script&lang=js"
export * from "./VizApp.vue?vue&type=script&lang=js"
import style0 from "./VizApp.vue?vue&type=style&index=0&id=45ab97ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports